export const REGULAR_PWG_SPORTS = Object.freeze(["NBA", "MLB", "WNBA", "SOCCER", "NFL", "CFB", "KBO", "NHL"]);

export function effectiveAvailability(entry, now = new Date()) {
  if (!entry || entry.state !== "SCHEDULED") return entry?.effectiveState || entry?.state || "ACTIVE";
  const timestamp = now instanceof Date ? now.getTime() : new Date(now).getTime();
  return timestamp >= Date.parse(entry.startAt) && timestamp < Date.parse(entry.endAt) ? "ACTIVE" : "OFFSEASON";
}

export function sportAccess(entry, { isAdmin = false, now = new Date() } = {}) {
  const state = effectiveAvailability(entry, now);
  if (isAdmin) return { visible: true, disabled: false, state };
  if (state === "MAINTENANCE") return { visible: true, disabled: true, state, message: entry?.message || "Temporarily unavailable." };
  return { visible: state === "ACTIVE", disabled: false, state };
}

export function visiblePwgSports({ baseSports = [], readySports = {}, availability = null, pwgEnabled = false, isAdmin = false, now } = {}) {
  const regular = new Set(REGULAR_PWG_SPORTS);
  return baseSports.filter((sport) => {
    if (!readySports[sport] || ["TEG", "MSI"].includes(sport)) return false;
    const operational = sportAccess(availability?.[sport], { isAdmin, now });
    return operational.visible && pwgEnabled && (isAdmin || regular.has(sport));
  });
}

export function resolveDirectSport({ requested, availableSports = [], availability = null, isAdmin = false } = {}) {
  const sport = String(requested || "").toUpperCase();
  const access = sportAccess(availability?.[sport], { isAdmin });
  if (availableSports.includes(sport)) return { sport, maintenance: access.disabled };
  return { sport: availableSports.includes("MLB") ? "MLB" : (availableSports[0] || null), maintenance: false };
}
